import {
  IRecognitionAllowance,
  IRecognitionAllowanceDetail,
  IRecognitionAllowanceRule,
} from 'types/income';
import { converters as tableConverters } from 'store/table';
import { loaders } from './recognition-allowances.loaders';
import {
  RecognitionAllowance,
  RecognitionAllowanceDetail,
  RecognitionAllowanceRule,
} from './recognition-allowances.types';

const convertAllowance = (
  allowance: IRecognitionAllowance,
): RecognitionAllowance => {
  return {
    id: allowance.id,
    firstName: allowance.firstName,
    lastName: allowance.lastName,
    fullName: [allowance.firstName, allowance.lastName]
      .filter(Boolean)
      .join(' '),
    assignedAllowance: allowance.assignedAllowance,
    spentPoints: allowance.spentPoints,
    balance: allowance.balance,
  };
};

const convertAllowances = (
  allowances: IRecognitionAllowance[],
): RecognitionAllowance[] => {
  return allowances.map(convertAllowance);
};

const convertAllowanceDetail = (
  detail: IRecognitionAllowanceDetail,
): RecognitionAllowanceDetail => {
  return {
    id: detail.id,
    frequency: detail.frequency,
    currencyValue: detail.currencyValue,
    pointsReceived: detail.pointsReceived,
    pointsSpent: detail.pointsSpent,
    validFrom: detail.validFrom,
    validTo: detail.validTo,
    createdAt: detail.createdAt,
  };
};

const convertAllowanceDetails = (
  details: IRecognitionAllowanceDetail[],
): RecognitionAllowanceDetail[] => {
  return details.map(convertAllowanceDetail);
};

const convertAllowanceRule = (
  achievement: IRecognitionAllowanceRule,
): RecognitionAllowanceRule => {
  return {
    id: achievement.id,
    points: achievement.points,
    frequency: achievement.frequency,
    employeeGroups: achievement.employeeGroups ?? [],
  };
};

const convertAllowanceRules = (
  achievements: IRecognitionAllowanceRule[],
): RecognitionAllowanceRule[] => {
  return achievements.map(convertAllowanceRule);
};

export const converters = {
  getAllowances: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getAllowances>>) => {
    const { total, page, pageSize, pages } = tableConverters.getTableData(data);

    return {
      items: convertAllowances(data.employees),
      total,
      page,
      pageSize,
      pages,
    };
  },
  getAllowanceDetails: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getAllowanceDetails>>) => {
    const { total, page, pageSize, pages } = tableConverters.getTableData(data);

    return {
      items: convertAllowanceDetails(data.allowances),
      total,
      page,
      pageSize,
      pages,
    };
  },
  getAllowanceRules: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getAllowanceRules>>) => {
    return convertAllowanceRules(data);
  },
};
